import React, { useState } from 'react';
import { Container, Button, ButtonGroup } from 'react-bootstrap';
import { Card, Typography, Space, Drawer, Input, Calendar, List } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';

const { Text, Title } = Typography;

const VaccineBoard = () => {
  const [open, setOpen] = useState(false);
  const [selectedVaccine, setSelectedVaccine] = useState(null);
  const [activeTab, setActiveTab] = useState('given'); // 'given' or 'due'

  const showDrawer = (item) => {
    setSelectedVaccine(item);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setActiveTab('given'); // Reset tab on close
  };

const vaccineData = [
  {
    category: "Hep A",
    items: [
      { name: "Hep A1", date: "Select Date", brand: "Select Brand", status: "pending" },
      { name: "Hep A2", date: "Select Date", brand: "Select Brand", status: "pending" },
    ]
  },
  {
    category: "MMR",
    items: [
      { name: "MMR 1", date: "Select Date", brand: "Select Brand", status: "pending" },
      { name: "MMR 2", date: "Select Date", brand: "Select Brand", status: "pending" },
    ]
  },
  {
    category: "TT",
    items: [
      { name: "Tetanus Toxo...", date: "Select Date", brand: "Select Brand", status: "pending" },
      { name: "Tetanus Toxo...", date: "Select Date", brand: "Select Brand", status: "pending" },
    ]
  },
  {
    category: "DTP",
    items: [
      { name: "DT", date: "Select Date", brand: "Select Brand", status: "pending" },
      { name: "Tdap", date: "27-12-2025", brand: "Select Brand", status: "urgent" },
    ]
  },
  {
    category: "Yearly",
    items: [
      { name: "Influenza", date: "Select Date", brand: "Select Brand", status: "pending" },
      { name: "Rabies", date: "Select Date", brand: "Select Brand", status: "pending" },
    ]
  },
  { category: "Other", items: [{ name: "Rabies 0 days", date: "Select Date", brand: "Select Brand" }] },
  { category: "Other 1", items: [{ name: "Japanese En...", date: "Select Date", brand: "Select Brand" }] },
  { category: "Other 2", items: [{ name: "Rubella", date: "Select Date", brand: "Select Brand" }] },
  { category: "Other 3", items: [{ name: "Rabies 0 days", date: "Select Date", brand: "Select Brand" }] },
  { category: "Other 4", items: [{ name: "Japanese En...", date: "Select Date", brand: "Select Brand" }] },
  { category: "Other 6", items: [{ name: "Rubella", date: "Select Date", brand: "Select Brand" }] },
    { category: "Other 7", items: [{ name: "Rabies 0 days", date: "Select Date", brand: "Select Brand" }] },
  { category: "Other 8", items: [{ name: "Japanese En...", date: "Select Date", brand: "Select Brand" }] },
  { category: "Other 9", items: [{ name: "Rubella", date: "Select Date", brand: "Select Brand" }] },
];

  // Buttons for Due Date view
  const dueIntervals = [
    "Today", "7 days", "15 days",
    "4 weeks", "1 month", "2 months",
    "3 months", "6 months", "1 year"
  ];

  // Buttons for Given Date view
  const brands = ['Rabipur', 'Rabivax', 'Verorab', 'Chirorab', 'Abhayrab', 'Berab'];

  return (
    <Container fluid className="mt-2 p-0" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      
      <style>{`
        .custom-scrollbar { display: flex; flex-wrap: nowrap; overflow-x: auto; padding-bottom: 15px; }
        .vaccine-column { min-width: 140px; max-width: 140px; margin-right: 1rem; }
        .column-header { background: white; border: 1px solid #d9d9d9; border-radius: 6px; padding: 8px 0; text-align: center; margin-bottom: 12px; }
        .vaccine-card { border-radius: 4px !important; color: white !important; cursor: pointer; border: none !important; }
        .bg-pending { background-color: #6a9ab0 !important; }
        .bg-urgent { background-color: #c0392b !important; }
        .date-text, .brand-text { font-size: 11px; opacity: 0.9; text-align: center; }
        .name-text { font-weight: 600; font-size: 13px; margin: 2px 0; text-align: center; }
        
        /* Drawer Styles */
        .drawer-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #eee; padding-bottom: 10px; }
        .grid-container { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin: 20px 0; }
        .interval-btn { border: 1px solid #17a2b8 !important; color: black !important; font-weight: 500 !important; padding: 8px 0 !important; }
        .interval-btn:hover { background-color: #f0faff !important; }
        .status-list .ant-list-item { padding: 10px; border-bottom: 1px solid #eee; cursor: pointer; font-size: 16px; font-weight: 500; }
        .status-list .ant-list-item:last-child { border-bottom: none; }
      `}</style>

      {/* Main Grid */}
      <div className="custom-scrollbar">
        {vaccineData.map((group, idx) => (
          <div key={idx} className="vaccine-column">
            <div className="column-header"><Text strong>{group.category}</Text></div>
            <Space direction="vertical" size={10} style={{ width: '100%' }}>
              {group.items.map((item, i) => (
                <Card 
                  key={i} 
                  size="small" 
                  onClick={() => showDrawer(item)}
                  className={`vaccine-card ${item.status === 'urgent' ? 'bg-urgent' : 'bg-pending'}`}
                >
                  <div className="date-text">{item.date}</div>
                  <div className="name-text">{item.name}</div>
                  <div className="brand-text">{item.brand}</div>
                </Card>
              ))}
            </Space>
          </div>
        ))}
      </div>

      {/* Detail Drawer */}
      <Drawer
        placement="right"
        onClose={onClose}
        open={open}
        width={400}
        closable={false}
      >
        <div className="drawer-header">
          <Button variant="link" className="text-danger p-0 fw-bold" style={{fontSize: '18px'}}>Reset</Button>
          <ButtonGroup size="sm">
            <Button 
              variant={activeTab === 'given' ? 'secondary' : 'light'} 
              onClick={() => setActiveTab('given')}
              style={{ border: '1px solid #ccc' }}
            >
              Given Date
            </Button>
            <Button 
              variant={activeTab === 'due' ? 'secondary' : 'light'} 
              onClick={() => setActiveTab('due')}
              style={{ border: '1px solid #ccc' }}
            >
              Due Date
            </Button>
          </ButtonGroup>
          <Button variant="link" className="p-0 fw-bold" style={{fontSize: '18px'}} onClick={onClose}>Close</Button>
        </div>

        <div className="text-center mt-3">
          <Title level={4} style={{ marginBottom: '15px' }}>{selectedVaccine?.name || 'Rabies 14 days'}</Title>
          <Input placeholder="Vaccination Note" style={{ textAlign: 'center', height: '40px' }} />
        </div>

        <div className="mt-3" style={{ textAlign: 'center' }}>
          <Text strong style={{ fontSize: '18px' }}>
             &lt; December {activeTab === 'due' ? '2023' : '2025'} &gt; 
          </Text>
          <Calendar fullscreen={false} headerRender={() => null} />
        </div>

        {/* Conditional Grid rendering based on Tab */}
        <div className="grid-container">
          {activeTab === 'given' ? (
            brands.map(brand => (
              <Button key={brand} variant="outline-info" size="sm" className="interval-btn">{brand}</Button>
            ))
          ) : (
            dueIntervals.map(interval => (
              <Button key={interval} variant="outline-info" size="sm" className="interval-btn">{interval}</Button>
            ))
          )}
        </div>

        {/* Action List (Only shown in Given Date mode typically, or matches bottom of image) */}
        {activeTab === 'given' && (
          <List className="status-list" bordered>
            <List.Item>Given by Other</List.Item>
            <List.Item>Given on Due Date</List.Item>
            <List.Item>Patient Refused</List.Item>
            <List.Item>Missed by Patient</List.Item>
            <List.Item>Not Applicable</List.Item>
          </List>
        )}
      </Drawer>
    </Container>
  );
};

export default VaccineBoard;